import React from 'react';
import './Titulo-EmptyTodos.css'

function EmptyTodos() {
  return <p className='Titulo-EmptyTodos'>¡Crea tu primer Meta!</p>;
}

export { EmptyTodos };
